<!--
  @Description 文件上传框
  @Date 2021-1-12
  @Author liufu
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="附件上传"
    width="300px"
    mask-closable
    @show="showModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <el-form-item prop="date">
        <el-date-picker
          v-model="form.date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认日期选择文件上传</el-button
    >

    <!-- 生成进度框 -->
    <vxe-modal
      v-model="showProress"
      title="进度"
      :showHeader="false"
      height="50"
      size="mini"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>

    <!-- 选择文件夹 -->
    <input
      type="file"
      ref="uploadExcel"
      v-show="false"
      id="open"
      multiple="multiple"
      @change="uploadFile"
    />
  </vxe-modal>
</template>
<script>
export default {
  name: 'AttachmentUpload',
  props: {},
  data() {
    return {
      formVisible: false,
      form: {
        date: '',
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
      },
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
    }
  },
  methods: {
    showModal() {
      this.form.date = ''
      this.$refs.uploadExcel.file = ''
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 上传
    async uploadFile(event) {
      let that = this
      if (
        !this.$parent.specialAuthority.super &&
        !this.$parent.specialAuthority.attachment
      ) {
        this.$message.warning('您没有权限上传')
        return
      }
      let length = event.target.files.length
      if (length === 0) {
        return
      }
      that.showProress = true
      let count = 0
      that.processStr = `${count}/${length}`
      that.percentage = 0
      for (let fileObj of event.target.files) {
        let formData = new FormData()
        formData.append('file', fileObj)
        let config = {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 60000 * 30,
        }

        const { data: res } = await that.$http.post(
          `/Base/BAttachment/upload/${this.form.date}`,
          formData,
          config
        )
        if (res.isSuccess) {
          count = count + 1
          that.percentage = Number(((100 * count) / length).toFixed(0))
          that.processStr = `${count}/${length}`
          if (count === length) {
            this.$refs.uploadExcel.file = ''
            setTimeout(() => {
              that.$message.success('上传成功')
              that.showProress = false
              that.$parent.refresh()
              that.$nextTick(() => {
                that.formVisible = false
              })
            }, 1000)
          }
        } else {
          this.$refs.uploadExcel.file = ''
          that.$messagebox('上传失败')
          that.showProress = false
          return
        }
      }
      event.target.value = ''
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      // const selectDate = this.ykDateFormat('yyyy-MM-dd', this.form.date)
      // this.$emit("sureHandler", selectDate);
      this.$refs.uploadExcel.click()
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        (res) => {
          flag = res
        },
        (err) => {
          flag = err
        }
      )
      return flag
    },
  },
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>
